import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Form, Card } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Chart from 'components/pages/haccp/report/regularReview/Chart';

// global
import { useConfirmModalState } from 'global/confirmModalState';
// function
import { getLoginInform } from 'function/login';
// types
import { RESPONSE_CODE } from 'types/const';
// api
import { factory, category1, category2, category3 } from 'api/haccp/commonApi';
import { regularReview } from 'api/haccp/report/regularReviewApi';

/*
 * 보고서 > 정기심사 브리핑
 */
const List = () => {
  /* recoil */
  const { setConfirmModal } = useConfirmModalState();

  /* state */
  const [adminYn, setAdminYn] = useState(null); // Y: 관리자, N: 이천,군산 담당자
  const [factoryOptions, setFactoryOptions] = useState(null);
  const [categoryOptions] = useState([
    { ctgryCd: 'prdt', ctgryNmKr: '제품' },
    { ctgryCd: 'rwmtr', ctgryNmKr: '원료' }
  ]);
  const [category1Options, setCategory1Options] = useState(null); // 대분류
  const [category2Options, setCategory2Options] = useState(null); // 중분류
  const [category3Options, setCategory3Options] = useState(null); // 소분류
  const [isSettingBtn, setIsSettingBtn] = useState(false);

  /* 조회조건 */
  const [pltCd, setPltCd] = useState('');
  const [ctgryGrpCd, setCtgryGrpCd] = useState('prdt');
  const [ctgry1Cd, setCtgry1Cd] = useState('');
  const [ctgry2Cd, setCtgry2Cd] = useState('');
  const [ctgry3Cd, setCtgry3Cd] = useState('');
  const [regDtSt, setRegDtSt] = useState(moment().startOf('month').toDate());
  const [regDtEn, setRegDtEn] = useState(moment().endOf('month').toDate());

  // 분류 선택에 따른 대분류, 중분류, 소분류 Title변경
  const [category1Title, setCategory1Title] = useState('');
  const [category2Title, setCategory2Title] = useState('');
  const [category3Title, setCategory3Title] = useState('');

  // chart data
  const [firstChartData, setFirstChartData] = useState({}); // 아플라톡신
  const [secondChartData, setSecondChartData] = useState({}); // 살모넬라
  const [thirdChartData, setThirdChartData] = useState({}); // 오크라톡신
  const [forthChartData, setForthChartData] = useState({}); // 제랄레논

  /* event */

  /* 조회일 선택 */
  const onDateChange = dates => {
    const [start, end] = dates;
    setRegDtSt(start);
    setRegDtEn(end);
  };

  /* 공장선택 */
  const onFactory = async e => {
    const { value } = e.target || {};

    setPltCd(value);
    setCtgryGrpCd('prdt');
    setCtgry1Cd('');
    setCtgry2Cd('');
    setCtgry3Cd('');
    setCategory1Options(null);
    setCategory2Options(null);
    setCategory3Options(null);

    const params = {
      ctgryGrpCd: 'prdt'
    };

    const response = await category1(params);

    const { code, list } = response || {};

    if (code !== RESPONSE_CODE.Success) return;

    categoryTitle('prdt');
    setCategory1Options(list);
  };

  /**
   * 분류선택 시 >  축종(대분류) API호출
   */
  const onCategory = async e => {
    const { value } = e.target || {};

    // 대분류 API 호출
    const params = {
      ctgryGrpCd: value
    };

    const response = await category1(params);

    const { code, list } = response || {};

    if (code !== RESPONSE_CODE.Success) return;

    setCtgry1Cd('');
    setCtgry2Cd('');
    setCtgry3Cd('');
    setCategory1Options(null);
    setCategory2Options(null);
    setCategory3Options(null);
    categoryTitle(value);
    setCtgryGrpCd(value);
    setCategory1Options(list);
  };

  /**
   * 축종(대분류) 선택시  > 등록명칭(중분류) API호출
   */
  const onCategory1 = async e => {
    const { value } = e.target || {};

    setCtgry1Cd(value);
    setCtgry2Cd('');
    setCtgry3Cd('');
    setCategory2Options(null);
    setCategory3Options(null);
    const factorySeq = factoryOptions?.find(e => e.pltCd === pltCd)?.seq;

    // 중분류 API호출
    const params = {
      pltCd: pltCd,
      pltCdSeq: factorySeq,
      ctgryGrpCd: ctgryGrpCd,
      ctgry1Cd: value
    };

    const response = await category2(params);

    const { code, list } = response || {};
    if (code !== RESPONSE_CODE.Success) return;

    setCategory2Options(list);
  };

  /**
   * 등록명칭(중분류) 선택시  > 등록명칭번호(소분류) API호출
   */
  const onCategory2 = async e => {
    const { value } = e.target || {};

    const factorySeq = factoryOptions?.find(e => e.pltCd === pltCd)?.seq;

    const params = {
      pltCd: pltCd,
      pltCdSeq: factorySeq,
      ctgryGrpCd: ctgryGrpCd,
      ctgry2Cd: value
    };

    // 소분류 API호출
    const response = await category3(params);

    const { code, list } = response || {};
    if (code !== RESPONSE_CODE.Success) return;
    setCtgry2Cd(value);
    setCtgry3Cd('');
    setCategory3Options(list);
  };

  /* 설정완료 버튼 */
  const onReportSetting = async () => {
    if (
      pltCd === '' ||
      ctgryGrpCd === '' ||
      ctgry1Cd === '' ||
      ctgry2Cd === ''
    ) {
      setConfirmModal({
        isOpen: true,
        title: '확인',
        message: `공장, 분류, ${category1Title}, ${category2Title} 선택해주세요.`,
        isConfirmBtn: true
      });

      return;
    }

    // date Format
    const { startDt, endDt } = dateConverter(regDtSt, regDtEn);

    const params = {
      pltCd: pltCd,
      ctgryGrpCd: ctgryGrpCd,
      ctgry1Cd: ctgry1Cd,
      ctgry2Cd: ctgry2Cd,
      ctgry3Cd: ctgry3Cd,
      inspReqDtSt: startDt,
      inspReqDtEn: endDt
    };

    Object.keys(params).forEach(
      key => params[key] === '' && delete params[key]
    );

    const response = await regularReview(params);

    const { code, data } = response || {};

    if (code !== RESPONSE_CODE.Success) return;

    const {
      position1 = {},
      position2 = {},
      position3 = {},
      position4 = {}
    } = data || {};

    // x축 Data labels Converting
    chartLabel(data);

    setFirstChartData(position1);
    setSecondChartData(position2);
    setThirdChartData(position3);
    setForthChartData(position4);
    setIsSettingBtn(true);
  };

  /**
   * x축 Data labels Converting
   * 기존 labels 데이터 + monthData
   */
  const chartLabel = chartObjData => {
    for (const [key, value] of Object.entries(chartObjData)) {
      const { labels = [], monthData = [] } = value || {};

      if (labels.length === 0) return;

      const data = labels?.map((e, index) => {
        e = `${e} (${monthData[index]}월)`;
        return e;
      });

      value.labels = data || [];
    }
  };

  // 분류선택에 따른 대,중,소분류 타이틀 변경
  const categoryTitle = ctgryGrpCd => {
    switch (ctgryGrpCd) {
      case 'prdt':
        // 제품
        setCategory1Title('축종');
        setCategory2Title('등록명칭');
        setCategory3Title('등록명칭번호');
        break;
      case 'proc':
        // 공정
        setCategory1Title('축종');
        setCategory2Title('공정명');
        setCategory3Title('의뢰명');
        break;
      case 'rwmtr':
        // 원료
        setCategory1Title('자재번호');
        setCategory2Title('외부자재번호');
        setCategory3Title('원료명');
        break;
    }
  };

  // data Format
  const dateConverter = (regDtSt, regDtEn) => {
    const startDt =
      regDtSt !== null ? moment(regDtSt).format('YYYY-MM-DD') : null;
    const endDt =
      regDtEn !== null ? moment(regDtEn).format('YYYY-MM-DD') : null;

    return { startDt, endDt };
  };

  /* 공장목록 API */
  const factoryList = async () => {
    const response = await factory();

    const { code, list } = response || {};
    if (code !== RESPONSE_CODE.Success) return;

    setFactoryOptions(list);
  };

  // 구분 > 대분류 API 호출
  const category1List = async () => {
    // 대분류 API 호출
    const params = {
      ctgryGrpCd: ctgryGrpCd
    };

    const response = await category1(params);

    const { code, list } = response || {};

    if (code !== RESPONSE_CODE.Success) return;

    categoryTitle(ctgryGrpCd);
    setCategory1Options(list);
  };

  /* 로그인 정보 */
  const loginInfo = () => {
    const { adminYn, pltCd } = getLoginInform();

    if (adminYn === 'Y') {
      setAdminYn(adminYn);
      return;
    }

    setPltCd(pltCd);
    setAdminYn(adminYn);
  };

  /* watch */
  useEffect(() => {
    // 공장 API 호출
    factoryList();
    // 구분 > 대분류 API 호출
    category1List();
    // 로그인정보
    loginInfo();
  }, []);

  useEffect(() => {
    if (adminYn === null) return;
    // onReportSetting();
  }, [adminYn]);

  return (
    <>
      <Card>
        <Card.Header>
          <Row className="align-items-center g-2">
            <Col>
              <h5 className="mb-0">정기 심사 브리핑</h5>
            </Col>
          </Row>
        </Card.Header>
        <Card.Body className="pt-0">
          <Form.Group className="mb-3">
            <Row className="ms-0 me-0 mt-3">
              {/* 공장 선택 select-box */}
              <Col sm={2} className="ps-1 pe-1">
                <Form.Select
                  size="sm"
                  onChange={e => onFactory(e)}
                  value={pltCd}
                  disabled={adminYn === 'N'}
                >
                  <option disabled value="">
                    공장선택
                  </option>
                  {factoryOptions?.map(option => (
                    <option key={option.pltCd} value={option.pltCd}>
                      {option.pltNmKo}
                    </option>
                  ))}
                </Form.Select>
              </Col>
              {/* 분류 Select Box*/}
              <Col sm={2} className="ps-1 pe-1">
                <Form.Select
                  required
                  size="sm"
                  onChange={e => onCategory(e)}
                  value={ctgryGrpCd}
                >
                  <option disabled value="">
                    분류선택
                  </option>
                  {categoryOptions?.map(option => (
                    <option key={option.ctgryCd} value={option.ctgryCd}>
                      {option.ctgryNmKr}
                    </option>
                  ))}
                </Form.Select>
              </Col>
              {/* 대분류 */}
              <Col sm={2} className="ps-1 pe-1">
                <Form.Select
                  required
                  size="sm"
                  onChange={e => onCategory1(e)}
                  value={ctgry1Cd || ''}
                >
                  <option disabled value="">
                    {category1Title}선택
                  </option>
                  {category1Options?.map((option, index) => (
                    <option key={index} value={option.ctgry1Cd}>
                      {option.ctgry1Nm}
                    </option>
                  ))}
                </Form.Select>
              </Col>
              {/* 중분류 */}
              <Col sm={2} className="ps-1 pe-1">
                <Form.Select
                  required
                  size="sm"
                  onChange={e => onCategory2(e)}
                  value={ctgry2Cd || ''}
                >
                  <option disabled value="">
                    {category2Title}선택
                  </option>
                  {category2Options?.map(option => (
                    <option key={option.ctgry2Cd} value={option.ctgry2Cd}>
                      {option.ctgry2Nm}
                    </option>
                  ))}
                </Form.Select>
              </Col>
              {/* 소분류 */}
              {ctgryGrpCd === 'rwmtr' && (
                <Col sm={2} className="ps-1 pe-1">
                  <Form.Select
                    required
                    size="sm"
                    onChange={({ target: { value } }) => setCtgry3Cd(value)}
                    value={ctgry3Cd || ''}
                  >
                    <option disabled value="">
                      {category3Title}선택
                    </option>
                    {category3Options?.map(option => (
                      <option key={option.ctgry3Cd} value={option.ctgry3Cd}>
                        {option.ctgry3Nm}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
              )}
            </Row>
            <Row className="ms-0 me-0 mt-3">
              {/* 조회기간 */}
              <Col sm={3} className="ps-1 pe-1">
                <DatePicker
                  locale="ko"
                  onChange={onDateChange}
                  startDate={regDtSt}
                  endDate={regDtEn}
                  selectsRange
                  dateFormat="yyyy-MM-dd"
                  className="form-control form-control-sm"
                  placeholderText="조회기간 선택"
                />
              </Col>
              <Col
                sm={`auto`}
                className="ps-1 pe-1 d-flex flex-row align-items-center"
              >
                <Button size="sm" onClick={onReportSetting}>
                  설정 완료
                </Button>
              </Col>
            </Row>
          </Form.Group>
          {/* 조회조건 선택 후 설정완료 버튼 선택*/}
          {isSettingBtn && (
            <Row className="ms-0 me-0 mt-3">
              {/* 아플라톡신 */}
              <Col sm={6} className="ps-1">
                <Chart
                  title={firstChartData.title}
                  chartData={firstChartData}
                />
              </Col>
              {/* 살모넬라 */}
              <Col sm={6} className="pe-1">
                <Chart
                  title={secondChartData.title}
                  chartData={secondChartData}
                  isOptionChange={true}
                />
              </Col>
              {/* 오클라톡신 */}
              <Col sm={6} className="ps-1">
                <Chart
                  title={thirdChartData.title}
                  chartData={thirdChartData}
                />
              </Col>
              {/* 제랄레논 */}
              <Col sm={6} className="pe-1">
                <Chart
                  title={forthChartData.title}
                  chartData={forthChartData}
                />
              </Col>
            </Row>
          )}
          {/* 설정완료 전 default text*/}
          {!isSettingBtn && (
            <div className="border border-300 d-flex align-items-center align-items-center justify-content-center min-vh-25 fw-bold">
              정기 심사 브리핑 조회조건을 선택해주세요.
            </div>
          )}
        </Card.Body>
      </Card>
    </>
  );
};

export default List;
